import Grid from '@componentPrimitives/Grid';
import { EventTicketedCard } from '@components/EntryCard/EntryCard.EventTicketed';
import { Entry } from '@lib/features/entries';
import { useEntryIndex } from '@lib/features/entryIndexes';
import { AnimatePresence, motion } from 'framer-motion';
import TicketIndexFeaturedCard from './TicketIndex.FeaturedCard';

const TicketIndexFeatured = () => {
  const isLoading = useEntryIndex((s) => s.isLoading);
  const featuredEntries = useEntryIndex((s) => s.featuredEntries ?? []);
  const isFiltered = useEntryIndex((s) => s.isFiltered);
  const page = useEntryIndex((s) => s.page);

  const entries = featuredEntries as Entry<'event', 'ticketed'>[];

  const [latestEntry, ...restEntries] = entries;

  const showFeaturedEntry = page === 1 && !isFiltered;

  if (!entries.length) return null;

  return (
    <AnimatePresence>
      {showFeaturedEntry && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: isLoading ? 0.2 : 1 }}
          exit={{ opacity: 0 }}>
          <Grid rowGutter cx={{ mB: 'gutter' }}>
            <Grid.Col>
              <TicketIndexFeaturedCard item={latestEntry} />
            </Grid.Col>
            {restEntries.map((entry) => {
              return (
                <Grid.Col key={entry.id} sm={6} md={4}>
                  <EventTicketedCard item={entry} />
                </Grid.Col>
              );
            })}
          </Grid>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TicketIndexFeatured;
